import React from "react"
import S from "./StyledMainOfferList"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCar, faMotorcycle } from "@fortawesome/free-solid-svg-icons"

const MainOfferList = () => {
  return (
    <S.TrackingWrapper>
      <div className="left-column">
        <S.TrackingTitle>
          Oferujemy pełnienie funkcji jako kierownik budowy, inspektor nadzoru
          inwestorskiego w zakresie:
        </S.TrackingTitle>
        <S.TrackingDescription>
          <ul>
            <li>
              Budowa obiektów od przejęcia placu budowy do uzyskania pozwolenia
              na użytkowanie
            </li>
            <li>Organizacja placów budowy</li>
            <li>Zarządzanie projektami, kontraktem</li>
            <li>Przygotowanie przedmiarów i kosztorysowanie</li>
            <li>Przeprowadzenie i organizacja przetargów</li>
            <li>Przygotowanie umowy o roboty budowlane</li>
          </ul>
        </S.TrackingDescription>
      </div>
      <div className="right-column">
        <S.TrackingMap></S.TrackingMap>
      </div>
    </S.TrackingWrapper>
  )
}

export default MainOfferList
